/**
 * This service is responsible to manage the view of pos values, display/hide, disable/enable
 * @param integrationConstant
 * @param _
 * @returns {*}
 */
function integrationViewPosService(integrationConstant, _) {
    const isMerchantAdminLocation = (location) => {
        return location === integrationConstant.LOCATION.merchantAdmin.label;
    };
    const isMerchantCreationLocation = (location) => {
        return location === integrationConstant.LOCATION.merchantCreation.label
    };
    const isOutletAdminLocation = (location) => {
        return location === integrationConstant.LOCATION.outletAdmin.label;
    };
    const isOutletCreationLocation = (location) => {
        return location === integrationConstant.LOCATION.outletCreation.label;
    };
    /* eslint complexity: 0*/
    const payAtTable = (pos, location) => {
        return {
            toggle: {
                disabled: pos.isComtrex || pos.isQuadranet || pos.isOmnivore || pos.isIBS || pos.isPilot || pos.isNcr || pos.isZonal,
                display: pos.isMicros || pos.isComtrex || pos.isDemo || pos.isQuadranet || pos.isOmnivore ||
                pos.isIBS || pos.isPilot || pos.isNcr || pos.isZonal
            },
            securityCode: {
                disabled: false,
                display: pos.isComtrex && isMerchantAdminLocation(location)
            },
            subFeature: { // TODO remove this or ref menu?
                disabled: false,
                display: pos.isMicros && (isMerchantAdminLocation(location) || isOutletAdminLocation(location))
            },
            orderAtTable: {
                disabled: false,
                display: (pos.isMicros || pos.isDemo)
            },
            orderAtTableSubFeature: {
                disabled: false,
                display: (pos.isMicros || pos.isDemo) &&
                (isMerchantAdminLocation(location) || isOutletAdminLocation(location))
            },
            orderAtTablePosMenuRef: {
                disabled: false,
                display: !pos.isDemo
            },
            posUrl: {
                disabled: false,
                display: pos.isQuadranet && isOutletAdminLocation(location)
            },
            omnivoreEmployeeId: {
                disabled: false,
                display: pos.isOmnivore
            },
            omnivorePatOrderTypeId: {
                disabled: false,
                display: pos.isOmnivore
            },
            omnivoreRevenueCenterId: {
                disabled: false,
                display: pos.isOmnivore
            },
            omnivoreTenderTypeId: {
                disabled: false,
                display: pos.isOmnivore
            },
            webhookId: {
                disabled: false,
                display: pos.isOmnivore && (isMerchantAdminLocation(location) || isMerchantCreationLocation(location)) &&
                    (!isOutletAdminLocation(location) && !isOutletCreationLocation(location))
            },
            usePaymentType: {
                disabled: false,
                display: (pos.isMicros || pos.isComtrex || pos.isDemo || pos.isQuadranet || pos.isOmnivore) &&
                isMerchantAdminLocation(location)
            }
        }
    };
    const barTab = (pos, location) => {
        return {
            toggle: {
                disabled: false,
                display: pos.isMicros || pos.isDemo
            },
            subFeature: {
                disabled: false,
                display: pos.isMicros && (isMerchantAdminLocation(location) || isOutletAdminLocation(location))
            },
            referenceMenu: {
                disabled: false,
                display: pos.isMicros && (isMerchantAdminLocation(location) || isOutletAdminLocation(location))
            }
        }
    };
    const collection = (pos, location) => {
        return {
            toggle: {
                disabled: pos.isPaymentez || pos.isEunoia,
                display: pos.isPaymentez || pos.isMicros || pos.isDemo || pos.isEunoia
            },
            collectionWithTimeSlots: {
                disabled: false,
                display: pos.isMicros || pos.isEunoia || pos.isDemo
            },
            intervalAndPreparationTime: {
                disabled: false,
                display: pos.isEunoia && (isMerchantAdminLocation(location) || isOutletAdminLocation(location))
            },
            referenceMenu: {
                disabled: false,
                display: pos.isMicros && (isMerchantAdminLocation(location) || isOutletAdminLocation(location))
            },
            warningTimeSlot: {
                disabled: false,
                display: pos.isEunoia && (isMerchantAdminLocation(location) || isOutletAdminLocation(location))
            },
            syncMenu: {
                disabled: false,
                display: pos.isMicros && (isMerchantAdminLocation(location) || isOutletAdminLocation(location))
            },
            paymentezAppKey: {
                disabled: false,
                display: pos.isPaymentez && isMerchantAdminLocation(location)
            },
            timeWindowInputs: {
                disabled: false,
                display: false
            },
            isTakeAwayMenuSync: {
                disabled: false,
                display: false
            }
        }
    };
    const barAndPat = (pos) => {
        return {
            isBillAutoUpdate: {
                disabled: pos.isComtrex || pos.isZonal || pos.isIBS || pos.isPilot || pos.isQuadranet || pos.isDemo,
                display: pos.isMicros || pos.isComtrex || pos.isZonal || pos.isIBS || pos.isPilot || pos.isQuadranet || pos.isNcr ||
                pos.isOmnivore ||pos.isDemo
            }
        }
    };

    return {
        isAtLeastOneToggleSelected(toggleSet, posType) {
            if (_.isEmpty(toggleSet)) {
                return false;
            }
            // returns false if it's not Micros
            return posType !== integrationConstant.POS_TYPE.Micros ||
                (posType === integrationConstant.POS_TYPE.Micros &&
                toggleSet.payAtTable ||
                toggleSet.barTab ||
                toggleSet.collection);
        },
        isBarAndPatChildComponentVisible(location, isBarOrPat) {
            const isMatchedLocation = isMerchantAdminLocation(location) || isOutletAdminLocation(location);
            return isMatchedLocation && isBarOrPat;
        },
        getPosMapDisplay(data, location) {
            const pos = {
                isMicros: data.posType === integrationConstant.POS_TYPE.Micros,
                isComtrex: data.posType === integrationConstant.POS_TYPE.Comtrex,
                isEunoia: data.posType === integrationConstant.POS_TYPE.Eunoia,
                isNcr: data.posType === integrationConstant.POS_TYPE.Ncr,
                isDemo: data.posType === integrationConstant.POS_TYPE.Demo,
                isQuadranet: data.posType === integrationConstant.POS_TYPE.Quadranet,
                isIBS: data.posType === integrationConstant.POS_TYPE.IBS,
                isPilot: data.posType === integrationConstant.POS_TYPE.Pilot,
                isZonal: data.posType === integrationConstant.POS_TYPE.Zonal,
                isOmnivore: data.posType === integrationConstant.POS_TYPE.Omnivore,
                isPaymentez: data.posType === integrationConstant.POS_TYPE.Paymentez
            };

            return {
                payAtTable: payAtTable(pos, location),
                barTab: barTab(pos, location),
                collection: collection(pos, location),
                barAndPat: barAndPat(pos)
            };
        },
        // this function manages feature display(payAtTable, barTab etc) for pos component, not the
        // components inside like input
        isFeatureVisible(options) {
            return {
                payAtTable: (options.posType === integrationConstant.POS_TYPE.Micros ||
                    options.posType === integrationConstant.POS_TYPE.Comtrex ||
                    options.posType === integrationConstant.POS_TYPE.Ncr ||
                    options.posType === integrationConstant.POS_TYPE.Demo ||
                    options.posType === integrationConstant.POS_TYPE.Quadranet ||
                    options.posType === integrationConstant.POS_TYPE.IBS ||
                    options.posType === integrationConstant.POS_TYPE.Pilot ||
                    options.posType === integrationConstant.POS_TYPE.Zonal ||
                    options.posType === integrationConstant.POS_TYPE.Omnivore
                ),
                barTab: (options.posType === integrationConstant.POS_TYPE.Micros ||
                    options.posType === integrationConstant.POS_TYPE.Demo
                ),
                collection: (options.posType === integrationConstant.POS_TYPE.Micros ||
                    options.posType === integrationConstant.POS_TYPE.Demo ||
                    options.posType === integrationConstant.POS_TYPE.Eunoia ||
                    options.posType === integrationConstant.POS_TYPE.Paymentez
                )
            };
        },
        isPosPartnerVisible(posType, location) {
            if (isOutletAdminLocation(location) || isOutletCreationLocation(location)) {
                return false;
            }
            return posType === integrationConstant.POS_TYPE.Quadranet ||
                posType === integrationConstant.POS_TYPE.IBS || posType === integrationConstant.POS_TYPE.Pilot;
        }
    }
}
angular
    .module('qkr.integration.settings')
    .factory('integrationViewPosService', integrationViewPosService);


// WEBPACK FOOTER //
// ./src/integration-settings/services/integration.view.pos.service.js